// Version Changelog Data
// Update this with each release

export const APP_VERSION = '2.4.0';

export const CHANGELOG = {
  '2.4.0': {
    date: '2026-05-16',
    title: 'Menu PDFs, CSV Export & Karaoke Auto-Off',
    isCritical: true,
    changes: [
      { type: 'feature', text: 'Admin: Download 8.5×11 double-sided menu PDF' },
      { type: 'feature', text: 'Admin: Download 11×17 large printable menu PDF' },
      { type: 'feature', text: 'Admin: Export menu items as CSV (with image links)' },
      { type: 'feature', text: 'Admin: Karaoke Mode Control card on dashboard' },
      { type: 'feature', text: 'Karaoke auto-disables nightly at 3am local time' },
      { type: 'improvement', text: 'Merchandise: add/edit/delete products with Stripe checkout (bypasses WooCommerce)' },
      { type: 'improvement', text: 'House rules: 20% gratuity → 20% service charge' },
      { type: 'improvement', text: 'Karaoke signups now DM the active DJ' },
      { type: 'bugfix', text: 'Fixed PDF download flow that previously showed raw JSON' }
    ]
  },
  '2.3.0': {
    date: '2026-03-25',
    title: 'Weekly Specials, Live Streaming & Timezone Support',
    isCritical: false,
    changes: [
      { type: 'feature', text: 'DJ live video streaming with side chat on Social Wall' },
      { type: 'feature', text: 'Location-based timezone for accurate time display' },
      { type: 'improvement', text: 'Updated weekly specials videos' },
      { type: 'improvement', text: 'Full cache clear on Update App for fresh experience' },
      { type: 'improvement', text: 'Simplified check-in: Client or Staff selection' }
    ]
  },
  '2.2.0': {
    date: '2026-02-27',
    title: 'Auto-Update & Cache Fix',
    isCritical: false,
    changes: [
      { type: 'improvement', text: 'Auto-update enabled - new versions apply automatically' },
      { type: 'bugfix', text: 'Fixed cache not clearing after deployment' },
      { type: 'improvement', text: 'Better image lazy loading' }
    ]
  },
  '2.1.0': {
    date: '2026-02-24',
    title: 'Enhanced PWA Features',
    isCritical: false,
    changes: [
      { type: 'feature', text: 'Version changelog popup on updates' },
      { type: 'feature', text: 'Background sync for offline posts' },
      { type: 'feature', text: 'Critical update force-refresh' },
      { type: 'improvement', text: 'Better offline support' }
    ]
  },
  '2.0.0': {
    date: '2026-02-24',
    title: 'Authentication & Location Features',
    isCritical: false,
    changes: [
      { type: 'feature', text: 'Google OAuth sign-in' },
      { type: 'feature', text: 'Email/password authentication' },
      { type: 'feature', text: 'Per-location feature toggles (Tip Staff, DJ Tips)' },
      { type: 'feature', text: 'PWA auto-update detection' },
      { type: 'improvement', text: 'Admin dashboard location cards' }
    ]
  },
  '1.0.0': {
    date: '2026-02-23',
    title: 'Initial Release',
    isCritical: false,
    changes: [
      { type: 'feature', text: 'Restaurant locations with check-in' },
      { type: 'feature', text: 'Social wall and DMs' },
      { type: 'feature', text: 'Menu with filtering' },
      { type: 'feature', text: 'Events and merchandise' },
      { type: 'feature', text: 'F&F Token economy' }
    ]
  }
};

// Get changelog for a specific version
export const getChangelog = (version) => CHANGELOG[version] || null;

// Get all changelogs since a version
export const getChangelogsSince = (fromVersion) => {
  const versions = Object.keys(CHANGELOG);
  const fromIndex = versions.indexOf(fromVersion);
  
  if (fromIndex === -1) return Object.entries(CHANGELOG);
  
  return Object.entries(CHANGELOG).slice(0, fromIndex);
};

// Check if any version since lastVersion is critical
export const hasCriticalUpdate = (lastVersion) => {
  const changelogs = getChangelogsSince(lastVersion);
  return changelogs.some(([_, data]) => data.isCritical);
};
